import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async login(data) {
        try{            
            const response = await axios.post(`User/login`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },    
    async login2(data) {
        try{            
            const response = await axios.post(`User/login2`, {
                item: data
            });
            return response;
        }catch (error){
            throw error
        }
    },     
    async switchAccount(userId) {
        try{            
            const response = await axios.post(`User/switch-account/${userId}`);
            return response;
        }catch (error){
            throw error
        }
    },    
    async loginByGoogle(recaptchaResponse, googleToken) {
        try{            
            const response = await axios.post(`User/login/google`, {
                userItem: {
                        recaptchaResponse: recaptchaResponse
                        ,googleToken: googleToken
                    }
            });
            return response;
        }catch (error){
            throw error
        }
    },     
    async loginByFacebook(data) {
        try{            
            const response = await axios.post(`User/login/facebook`, {
                userItem: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },     
    async getMyProfile() {
        try{            
            const response = await axios.get(`User/myprofile`)
            return response
        }catch (error){
            throw error
        }
    },    
    //used in Update Personal Details in MyProfile page
    async updateMyPesonalDetails(data) {
        try{            
            const response = await axios.post(`User/update`, {
                item: data
            })
            return response;
        }catch (error){
            throw error
        }
    },
    async updateById(data) {
        try{            
            const response = await axios.post(`User/update/byid`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },
    async onBoarded() {
        try{            
            const response = await axios.post(`User/onboarded`);
            return response;
        }catch (error){
            throw error
        }
    },
    async updateAvatar(data) {
        try{            
            const response = await axios.post(`User/update/avatar`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },
    async updateUINav(data) {
        try{            
            const response = await axios.post(`User/update/uinav`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },
    async updateTwoFA(data) {
        try{   
            const response = await axios.post(`User/update/twoFA`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },
    async updateNotifications(data) {
        try{   
            const response = await axios.post(`User/update/notifications`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },
    async updateTheme(data) {
        try{   
            const response = await axios.post(`User/update/theme`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },
    async updateMyDetails(data) {
        try{            
            const response = await axios.post(`User/update/mydetails`, {
                item: data
            });
            
            return response;
        }catch (error){
            throw error
        }
    },
    async getUsers() {
        try{
            const response = await axios.get(`User`);            
            return response;
        }catch (error){
            throw error
        }
    },
    async getUserById(userId) {
        try{
            const response = await axios.get(`User/${userId}`,
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })       
            return response;
        }catch (error){
            throw error
        }
    },
    async getByCompany() {
        try{          
            const response = await axios.get(`User/bycompany`);            
            return response;
        }catch (error){
            throw error
        }
    },
    async logout(data) {
        try {
            await axios.post(`User/logout`,{
                item: data
            }); 
        }catch (error) {
            throw error
        }
    },
    async changePassword(id, newPassword, recaptchaResponse) {
        try {
            var data = {
                userId: id,
                password: newPassword,
                recaptchaResponse: recaptchaResponse
            }
            const response = await axios.post(`User/change_password`,{
                userItem: data
            });
            return response;  
        }catch (error) {
            throw error
        }
    },
    async resetPassword(email, recaptchaResponse) {
        try {
            var data = {
                email: email,
                recaptchaResponse: recaptchaResponse
            }
            const response = await axios.post(`User/reset_password`, {
                userItem: data
            });
            return response;  
        }catch (error) {
            throw error
        }
    },
    async search(email) {
        try {
            var data = {
                email: email
            }
            const response = await axios.post(`User/search`, {
                userItem: data
            },
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })
            return response;  
        }catch (error) {
            throw error
        }
    },
    async deactivate(userId) {
        try{
            const response = await axios.post(`User/deactivate/${userId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })
            return response;
        }catch (error){
            throw error
        }
    },
}